import { safeReturn, routeUrl } from './navigation'
const KEY = 'dtviso-login-intent-v1'
const identifier = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(value)
export function returnIntent(name, query = {}) {
  name = safeReturn(name)
  const result = { name, query: {} }
  if (name === 'preview') {
    if (identifier(query.templateId)) result.query.templateId = query.templateId
    if (identifier(query.jobId)) result.query.jobId = query.jobId
    if (query.changePhotos === '1') result.query.changePhotos = '1'
  }
  return result
}
export function rememberLoginIntent(route, storage = window.sessionStorage) {
  const intent = returnIntent(route.name, route.query)
  try { storage.setItem(KEY, JSON.stringify({ ...intent, expires: Date.now() + 30 * 60 * 1000 })) } catch (_) { /* URL still preserves public template */ }
  return intent
}
export function recalledLoginIntent(name, storage = window.sessionStorage) {
  try {
    const value = JSON.parse(storage.getItem(KEY))
    if (value && value.expires > Date.now() && value.expires <= Date.now() + 30 * 60 * 1000 && (!name || value.name === name)) return returnIntent(value.name, value.query)
  } catch (_) { /* unavailable storage */ }
  return returnIntent(name)
}
export function clearLoginIntent(storage = window.sessionStorage) { try { storage.removeItem(KEY) } catch (_) { /* optional */ } }
export function loginIntentUrl(intent) {
  // Public template IDs may cross browsers; private task IDs stay in tab-local storage.
  return routeUrl('login', { returnTo: intent.name, ...(intent.query.templateId ? { templateId: intent.query.templateId } : {}) })
}
